import React from 'react';

interface FilePreviewProps {
    file: File;
}

export const FilePreview = React.memo(({ file }: FilePreviewProps) => {
    if (file.type.startsWith('image/')) {
        return (
            <div className="relative mb-2">
                <img
                    src={URL.createObjectURL(file)}
                    alt="Uploaded image"
                    className="max-h-[400px] min-w-[200px] max-w-full h-auto rounded-lg border border-border"
                />
            </div>
        );
    }

    return (
        <div className="flex items-center gap-2 p-2 border rounded-md bg-muted/50">
            <div className="w-8 h-8 bg-muted rounded flex items-center justify-center">
                <span className="text-xs">📎</span>
            </div>
            <span className="text-sm truncate">{file.name}</span>
        </div>
    );
});

FilePreview.displayName = 'FilePreview';
